import React from 'react';
import PropTypes from 'prop-types';

import useCustomPageCatalog from '../hook/UseCustomPageCatalog';
import CustomPageDetailContentWrapper from './CustomPageDetailContentWrapper';
import CustomPageDetailContentCatalogLargeLayoutItem from './CustomPageDetailContentCatalogLargeLayoutItem';
import CustomPageDetailContentCatalogModalItem from './CustomPageDetailContentCatalogModalItem';

import CatalogRowCard from '../../catalog/CatalogRowCard';

const CustomPageDetailContentCatalogLargeLayout = (props) => {

  console.log('Rendering catalog-large');

  let {
    companyContractDisplayId,
    pageBlock
  } = props;

  let {
    getCatalogs,
  } = useCustomPageCatalog();

  const getCatalogItems = () => {
    return getCatalogs(companyContractDisplayId, pageBlock).map((catalog, i) => {
      return <CatalogRowCard key={i} {...catalog} />;
    });
  };

  const getCatalogItemModals = () => {
    let catalogItemModals = pageBlock.pageBlockItems.map(function(pageBlockItem, i){
      return <CustomPageDetailContentCatalogModalItem pageBlockItem={pageBlockItem} key={i} />;
    });
    return catalogItemModals;
  };

  return (
    <CustomPageDetailContentWrapper pageBlock={pageBlock}>
      <ul className="m_floatList s_catalog">
        {getCatalogItems()}
      </ul>
    </CustomPageDetailContentWrapper>
  );

};

CustomPageDetailContentCatalogLargeLayout.propTypes = {
  pageBlock: PropTypes.any.isRequired
};

export default CustomPageDetailContentCatalogLargeLayout;
